import { Pipe, PipeTransform } from "@angular/core";
import { CampaingService } from "../../providers/campaing.service";
import { Observable } from "rxjs/Observable";

@Pipe({
  name: "audience"
})
export class AudiencePipe implements PipeTransform {

  constructor(
    private campaingData: CampaingService
  ) { }

  transform(audienceId: string): Observable<any> {
    return this.campaingData.detailAudience(audienceId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/audicence/audience.ts